import {combineReducers}  from 'redux';

import projectReducer from '../component/project/redux/projectReducer';

const rootReducer = combineReducers(
    projectReducer
);

export default rootReducer;